<template>
  <div>
    <vue-headful title="Maak je profiel compleet" />
    <Header page_title="Maak je profiel compleet" goBackClass="invisible" :do-not-show-all="!this.prevRoute || this.prevRoute.name !== 'applicant-edit'" />
    <div class="pt-3 px-4 mx-2 pb-4 questionnaire">
      <div class="container-fluid px-0 pb-1 mb-2">
        <form @submit.prevent="onSubmit">
          <div class="step-question">
            <button type="submit" ref="submit" hidden>submit</button>
            <template v-if="!prevRoute || (prevRoute.name !== 'applicant-edit' && prevRoute.name !== 'applicant-dashboard')">
              <register-steps v-if="sub_branch == '2'" :steps="{1:'Gegevens',2:'Ervaringen',3:'Aan de slag!'}" :totalAnswered="answered" currentStep="2"></register-steps>
              <register-steps v-else :steps="{1:'Gegevens',2:'Opleidingen',3:'Ervaringen',4:'Aan de slag!'}" :totalAnswered="answered" currentStep="3"></register-steps>
            </template>
            <div ref="step">
              <template v-if="(step === 1 && questions[1]) || (sub_branch==='1,2' && step === 7)">
                <div class="sd-title medium step-container">
                  <span class="steps">{{ step }}/{{ steps }}</span>
                  {{ questions[step].display }}
                </div>
                <div class="form pt-2">
                  <div class="slide-bar" v-if="form.user_answers[questions[step].id]">
                    <VueSlideBar
                      v-model="form.user_answers[questions[step].id]['answer']"
                      :min="0"
                      :max="50"
                      :value="form.user_answers[questions[step].id]['answer']"
                    >
                      <template slot="tooltip">
                        <div class="range-tooptip"></div>
                        <div class="tooptip value">
                          {{ form.user_answers[questions[step].id]["answer"]  }}
                        </div>
                      </template>
                    </VueSlideBar>
                    <div class="range-values clearfix">
                      <div class="float-left">
                        <small>0</small>
                      </div>
                      <div class="float-right">
                        <small>50</small>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="(step > 1 && step <= 6 && sub_branch === '1') || (step > 1 && step <= 6 && sub_branch === '2' || ( step > 1 && step <= 6 || step > 7 && step <= 12 && sub_branch === '1,2'))">
                <div class="sd-title medium step-container">
                  <span class="steps">{{ step }}/{{ steps }}</span>
                  {{ questions[step].display }}
                </div>
                <div class="form">
                  <div v-if="step == 6 && (sub_branch === '1' || sub_branch === '1,2') " class="list-unstyled">
                    <div class="form-group">
                      <textarea class="form-control" maxlength="400" placeholder="Welke daginvulling kan jij bieden als invaller voor de klas, welke onderwijservaring heb jij en welke (aanvullende) relevante diploma’s heb jij? Max 400 karakters" v-model="form.user_answers[questions[step].id]['answer']"  rows="5"></textarea>
                    </div>
                  </div>
                  <template v-else-if="(step === 6 && sub_branch === '2') || (step === 12 && sub_branch === '1,2')">
                    <subjects ref="subjects" v-model="subject_answers" :answers-given="subject_answers" :question="questions[step]" :answers="answers[step]"></subjects>
                    <div class="form subject-addition sd-col-12">
                      <div class="form-group" v-if="(!$refs.subjects || !$refs.subjects.questionAlreadyFilledIn) || (form.about_subject_answers && form.about_subject_answers.length > 0)">
                        <b>Toelichting bevoegdheid</b>
                        <textarea class="form-control" maxlength="400" placeholder="Vertel ons over je lesbevoegdheid (1e of 2e graads, of ben je nog in opleiding?) en je werkervaring. Zijn er nog andere vakken die je zou kunnen geven naast dit hoofdvak?" rows="5"
                                  v-model="form.about_subject_answers" v-if="!$refs.subjects || !$refs.subjects.questionAlreadyFilledIn">
                        </textarea>
                        <div v-if="$refs.subjects && $refs.subjects.questionAlreadyFilledIn">{{ form.about_subject_answers }}</div>
                      </div>
                    </div>
                  </template>
                  <ul v-else class="list-unstyled">
                    <li v-for="item in answers[step]" v-bind:key="item.id">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[step].id]['answer_id'][
                              item.id
                            ]
                          "
                          :value="item.id"
                          v-bind:id="`position-` + item.id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`position-` + item.id"
                          >{{ item.answer }}</label
                        >
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </div>
          </div>
          <div hidden>
            <v-stepper ref="stepper" :steps="steps" v-model="step"></v-stepper>
          </div>
        </form>
      </div>
    </div>
    <div class="step next-btn">
      <div class="px-4 mx-2">
        <button
          v-if="step < steps && prevRoute && prevRoute.name === 'applicant-edit'"
          type="button"
          title="Volgende"
          class="btn btn-warning btn-block"
          @click="nextStep"
        >
          Volgende
        </button>
        <button
          v-else-if="step < steps"
          type="button"
          title="Volgende stap"
          class="btn btn-warning btn-block"
          @click="nextStep"
        >
          Volgende stap
        </button>
        <!-- @click="$refs.stepper.next()" -->
        <!-- if action is save Opslaan
        if action is next Volgende-->
        <button
          v-if="step == steps"
          type="button"
          title="Volgende"
          class="btn btn-warning btn-block"
          @click="triggerSubmit"
        >
          {{ action == "next" ? "Volgende" : "Opslaan" }}
        </button>
      </div>
    </div>
    <div v-if="done" class="fullscreen-notif position-fixed">
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div class="icon svg mb-4 pb-1">
              <svg-icon icon="success"></svg-icon>
            </div>
            <div class="sd-title large text-uppercase bold text-white text-center mb-4">
              Dank voor het invullen!
            </div>
<!--            <div v-if="action == 'save' && original_sub_branch == '2'">-->
<!--              Je profiel is bijna compleet, we hebben nog een laatste vraag voor je!-->
<!--            </div>-->
            <div>
              Nu je profiel helemaal compleet is, word je nog beter gevonden. Op naar de leukste (inval)opdrachten!
            </div>
          </div>
        </div>

        <div class="footer-btn">
          <div class="container-fluid px-4 mx-2">
            <router-link
              v-if="action == 'next' || (action != 'next' && education !== null && Object.keys(education).length < 5 && original_sub_branch != '2')"
              :to="{
                name: 'applicant-step_3',
                params: { action: 'next' }
              }"
              title="Bekijk"
              class="btn btn-light btn-block"
              v-ripple="'rgba(192, 189, 187, 0.35)'"
            >
              Doorgaan met educatie
            </router-link>
<!--            <router-link-->
<!--              v-else-if="action == 'save' && original_sub_branch == '2'"-->
<!--              :to="{-->
<!--                name: 'applicant-step-5',-->
<!--                params: { action: 'next' }-->
<!--              }"-->
<!--              title="Bekijk"-->
<!--              class="btn btn-light btn-block"-->
<!--              v-ripple="'rgba(192, 189, 187, 0.35)'"-->
<!--            >-->
<!--              Doorgaan naar de laatste vraag-->
<!--            </router-link>-->
            <router-link
              v-else
              :to="{
                name: 'applicant-dashboard'
              }"
              title="Naar mijn dashboard"
              class="btn btn-light btn-block"
              v-ripple="'rgba(192, 189, 187, 0.35)'"
              >Naar mijn dashboard</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VStepper } from "vue-stepper-component";
import VueSlideBar from "vue-slide-bar";
import Subjects from "@/components/subjects.vue";

export default {
  components: {
    VStepper,
    VueSlideBar,
    Subjects
  },
  data: function() {
    return {
      sub_branch: localStorage.getItem('subBranch'),
      original_sub_branch: localStorage.getItem('subBranch'),
      subject_answer_id: 56,
      raw: "",
      years_experience: 0,
      steps: 0,
      step: 1,
      answered: 0,
      done: null,
      user: "",
      education: null,
      questions: {},
      questions_array: {},
      answers_array: {},
      answers: {},
      subject_answers: {},
      form: {
        user_answers: {},
        about_subject_answers: null
      },
      prevRoute: null
    };
  },
  created() {
    if (this.question_branch)
    {
      this.sub_branch = this.question_branch;
      localStorage.setItem("questionBranch", this.question_branch)
    }
    else if(localStorage.getItem("questionBranch"))
    {
      this.sub_branch = localStorage.getItem("questionBranch");
    }

    this.steps = this.getNumberOfSteps()
  },
  props: ["action", "question_branch"],
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    step: {
      handler() {
        this.answered = Math.ceil((this.step / this.steps) * 100);
      }
    },
    form: {
      handler: function() {
        localStorage.setItem("form-pending", JSON.stringify(true));
      },
      deep: true
    }
  },
  methods: {
    async fetchData() {
      await this.getQuestions();
      await this.getAnswers();
      await this.fillForm();
      await this.getUserAnswers();
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user.education) {
        this.education = JSON.parse(this.user.education);
      }
      localStorage.removeItem("form-pending");
    },
    // get questions
    async getQuestions() {
      let promises = [];
      var q_url = this.$apiURI + "/question/experience/1/";
      var i = 1;
      var question_number = 1;

      var sub_branch = this.sub_branch === '1,2'
          ? "/1"
          : "/" + this.sub_branch;

      while (i <= this.steps) {
        //switch to sub_branch 2 question flow if 1 is done
        if(this.sub_branch === '1,2' && question_number > 6) {
          question_number = 1;
          sub_branch = "/2"
        }

        //assign questions
        promises.push(
          new Promise(resolve => {
            this.$http({
              method: "GET",
              url: q_url + question_number + sub_branch
            }).then(
              result => {
                var q_id = result.data.data[0].id;
                var q_number = result.data.data[0].number;

                if(this.sub_branch === '1,2' && result.data.data[0].sub_branch === 2) {
                  q_number = parseInt(q_number) + 6;
                }

                this.$set(this.questions, q_number, {
                  id: result.data.data[0].id,
                  display: result.data.data[0].display
                });
                this.$set(this.questions_array, q_number, q_id);
                resolve();
              },
              error => {
                console.error(error);
              }
            );
            i++;
            question_number++;
          })
        );
      }
      return Promise.all(promises);
    },
    //assign answers
    async getAnswers() {
      let promises = [];
      var a_url = this.$apiURI + "/answers/1/";
      var sub_branch = this.sub_branch === '1,2'
          ? "/1"
          : "/" + this.sub_branch;

      if(this.sub_branch === '1') {
        var arr = {
          position: 2,
          audience: 3,
          education_experience: 4,
          denomination: 5
        };
      }else if(this.sub_branch === '2') {
        var arr = {
          position: 2,
          group_experience: 3,
          education_experience: 4,
          special_education_experience: 5,
          subject: 6,
        }
      }else if (this.sub_branch === '1,2') {
        var arr = {
          position: 2,
          audience: 3,
          education_experience: 4,
          denomination: 5
        }
        var arr2 = {
          position: 8,
          group_experience: 9,
          education_experience: 10,
          special_education_experience: 11,
          subject: 12,
        };
      }

      Object.keys(arr).forEach(itemKey => {
        promises.push(
          new Promise(resolve => {
            this.$http({
              method: "GET",
              url: a_url + itemKey + sub_branch
            }).then(
              result => {
                this.$set(
                  this.answers,
                  arr[itemKey], //qnumber
                  result.data.data
                );

                var answerIds = {};
                for (var v in result.data.data) {
                  answerIds[result.data.data[v].id] = false;
                }
                this.$set(this.answers_array, arr[itemKey], answerIds);
                resolve();
              },
              error => {
                console.error(error);
              }
            );
          })
        );
      });

      if(this.sub_branch === '1,2') {
        sub_branch = '/2'
        Object.keys(arr2).forEach(itemKey => {
          promises.push(
            new Promise(resolve => {
              this.$http({
                method: "GET",
                url: a_url + itemKey + sub_branch
              }).then(
                  result => {
                    this.$set(
                        this.answers,
                        arr2[itemKey], //qnumber
                        result.data.data
                    );

                    var answerIds = {};
                    for (var v in result.data.data) {
                      answerIds[result.data.data[v].id] = false;
                    }
                    this.$set(this.answers_array, arr2[itemKey], answerIds);
                    resolve();
                  },
                  error => {
                    console.error(error);
                  }
              );
            })
          );
        });
      }

      return Promise.all(promises);
    },
    async fillForm() {
      return new Promise(resolve => {
        Object.keys(this.questions_array).forEach(questionNumber => {
          var question_id = this.questions_array[questionNumber];
          if (questionNumber == 1) {
            this.$set(this.form.user_answers, question_id, {
              answer: 0
            });
          } else if (questionNumber == 6) {
            this.$set(this.form.user_answers, question_id, {
              answer: ""
            });
          } else {
            this.$set(this.form.user_answers, question_id, {
              answer_id: this.answers_array[questionNumber]
            });
          }
        });
        resolve();
      });
    },
    async getUserAnswers() {
      return new Promise((resolve, reject) => {
        var url = "applicant/answers/raw/1/experience";

        if(this.sub_branch !== '1,2') {
          url = url + '/' + this.sub_branch;
        }
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/" + url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data.data) {
              this.raw = resp.data.data;
              for (var obj in this.raw) {
                if(this.raw[obj].question_id === this.subject_answer_id) {
                  if(!this.subject_answers.hasOwnProperty(this.raw[obj].answer_id)) {
                    this.$set(this.subject_answers, this.raw[obj].answer_id , {});
                  }
                  this.$set(this.subject_answers[this.raw[obj].answer_id], this.raw[obj].extra_info, this.raw[obj].answer);
                  continue;
                }
                if (this.raw[obj].question_id === 1 || this.raw[obj].question_id === 7 || this.raw[obj].question_id === 31 || this.raw[obj].question_id === 52 || this.raw[obj].question_id === 59) {
                  const val = this.raw[obj].answer;

                  if (this.form.user_answers[this.raw[obj].question_id]) {
                    this.$set(this.form.user_answers[this.raw[obj].question_id], 'answer', val);
                  } else {
                    this.$set(this.form.user_answers, this.raw[obj].question_id, {
                      answer: val
                    });
                  }

                  if (this.raw[obj].question_id === 59) {
                    this.form.about_subject_answers = val;
                  }
                }
               else {
                  if (this.form.user_answers[this.raw[obj].question_id] && this.form.user_answers[this.raw[obj].question_id]["answer_id"]) {
                    this.$set(this.form.user_answers[this.raw[obj].question_id]["answer_id"], this.raw[obj].answer_id, true);
                  }
                }
              }
            }
            return resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            return reject(null);
          });
      });
    },
    triggerSubmit() {
      var elem = this.$refs.submit;
      elem.click();
    },
    async NavigateNextQuestions() {
      this.addSubjectAnswers();
      var next = this.validateForm();

      if(next)
      {
        if(this.sub_branch === '2')
        {
          await this.$router.replace({
                name: "applicant-step-5",
                params: {
                  answers: this.form.user_answers
                },
              }
          ).catch((err) => {
            throw new Error(`error routing ${err}`);
          });
        }
      }
    },
    addSubjectAnswers() {
      if((this.sub_branch === '1,2' || this.sub_branch === '2')
        && Object.keys(this.subject_answers).length !== 0){

        this.form.user_answers[this.subject_answer_id] = this.subject_answers;
      }
    },
    async onSubmit() {
      this.addSubjectAnswers();
      var next = this.validateForm();
      if (next) {
        // continue
        await this.saveExperience();
        await this.updateLocalUser();
        localStorage.removeItem("questionBranch");
      }
    },
    async saveExperience() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var urlSubBranch = this.sub_branch == '1,2' ? '1/2' : this.sub_branch;
        var url = this.$apiURI + "/user_answer/experience/1/" + urlSubBranch;
        let formData = {
          user_answer: this.form["user_answers"],
          about_subject_answers: this.form["about_subject_answers"],
          limit: 10
        };
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            this.done = true;
            console.log(this.done);
            localStorage.removeItem("form-pending");

            if (typeof dataLayer !== "undefined") {
              const dataLayerEvent = {
                event: "TeacherExperienceEdit",
                eventCategory: "Teacher",
                eventAction: "Teacher – Experience edit",
                eventLabel: "",
                eventValue: "1"
              };
              dataLayer.push(dataLayerEvent);
            }

            const prevName = this.prevRoute && this.prevRoute.name;
            const isSignupFlow = prevName !== "applicant-edit" && prevName !== "applicant-dashboard";
            if (typeof dataLayer !== "undefined" && isSignupFlow && (this.sub_branch === "1" || this.sub_branch === "2" || this.sub_branch === "1,2")) {
              const signUpCompletedEvent = {
                event: "TeacherSignUpAccountCompleted",
                eventCategory: "Teacher",
                eventAction: "Teacher - Sign up account completed",
                eventLabel: "",
                eventValue: "1"
              };
              dataLayer.push(signUpCompletedEvent);
            }

            resolve();
          })
          .catch(() => {
            // console.log(error.response.data);
            this.done = true;
            // console.log(this.done);
            localStorage.removeItem("form-pending");
            resolve();
          });
      });
    },
    nextStep() {
      var next = this.validateForm();
      window.scrollTo(0,0);
      if (next) {
        this.$refs.stepper.next();
      }
    },
    getNumberOfSteps() {
      if(this.sub_branch === '1') {
        return 6;
      }

      if(this.sub_branch === '2') {
        return 6;
      }

      if(this.sub_branch === '1,2') {
        return 12;
      }
    },
    validateForm() {
      if(this.step === 6 && (this.sub_branch === '1,2' || this.sub_branch === '1')) {
        if(this.form.user_answers[this.questions[6].id]['answer'] === '') {
          alert("Vul de daginvulling in om door te gaan.");
          return false;
        }
        else
          return true;
      } else {
        var $checkboxes = $('input[type="checkbox"]:visible');
        if ($checkboxes.length) {
          var checkedCheckboxes = $('input[type="checkbox"]:visible:checked')
            .length;
          if (!checkedCheckboxes && !((this.sub_branch == '2' && this.step == 5) || (this.sub_branch == '1,2' && this.step == 11))) {
            alert("Selecteer één of meerdere antwoorden om door te gaan.");
            return false;
          }
        } else if (((this.sub_branch == '2' && this.step == 6) || (this.sub_branch == '1,2' && this.step == 12))){
          let hasAnswered = false;
          Object.keys(this.subject_answers).forEach(key => {
            const answers = this.subject_answers[key];
            if (answers) {
              Object.keys(answers).forEach(answersKey => {
                if (answers[answersKey] !== false) {
                  hasAnswered = true;
                }
              });
            }
          });
          if (!hasAnswered) {
            alert("Selecteer één of meerdere graden om door te gaan.");
          }
          return hasAnswered;
        } else {
          return true;
        }
      }
      return true;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.savePending(to, from, next);
  }
};
</script>

<style scoped>
.card {
  border-radius: 5px;
  overflow: hidden;
}
.card-body {
  min-height: 135px;
}

.range-values div {
  position: relative;
  margin-top: -2px;
}
.range-values .float-left {
  left: -3px;
}
.range-values .float-right {
  right: -8px;
}

.fullscreen-notif .icon.svg svg {
  right: -22px;
}

/deep/.step-question .slide-bar {
  padding-left: 10px;
  padding-right: 10px;
}

.step-question .notification-container {
  margin-top: 25px;
}
.questionnaire {
  padding-bottom:4rem!important;
}
</style>
